export enum WidgetStatus {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
}

export enum DialFirst {
  CONTACT = 'CONTACT',
  INTERNAL = 'INTERNAL',
}

export enum WidgetConfigurationPlacementMode {
  FLOATING = 'FLOATING',
  INLINE = 'INLINE',
}

export enum WidgetConfigurationVerticalPosition {
  TOP = 'TOP',
  CENTER = 'CENTER',
  BOTTOM = 'BOTTOM',
}

export enum WidgetConfigurationHorizontalPosition {
  LEFT = 'LEFT',
  CENTER = 'CENTER',
  RIGHT = 'RIGHT',
}

export type WidgetConfigurationStyles = {
  accentColor: string;
  backgroundColor: string;
} & (
  | {
      placementMode: WidgetConfigurationPlacementMode.FLOATING;
      verticalPosition: WidgetConfigurationVerticalPosition;
      horizontalPosition: WidgetConfigurationHorizontalPosition;
      verticalOffset: string;
      horizontalOffset: string;
    }
  | { placementMode: WidgetConfigurationPlacementMode.INLINE }
);

export interface WidgetConfigurationLogo {
  source: File | string | null;
  width: number;
  height: number;
}

export interface WidgetConfigurationContent {
  title: {
    en: string;
    it: string;
  };
  button: {
    en: string;
    it: string;
  };
  showHeader: boolean;
  nameAvailable: boolean;
  namePlaceholder: { en: string; it: string };
  emailAvailable: boolean;
  emailPlaceholder: { en: string; it: string };
  phoneCountries: string[];
  defaultPhoneCountry: string | null;
}

export enum WidgetConfigurationSecurityMode {
  ALLOW_ALL = 'ALLOW_ALL',
  LIMITED_DOMAINS = 'LIMITED_DOMAINS',
}

export type WidgetConfigurationSecurity = {
  enabledCountryCodes: string[];
} & (
  | { domainRestrictionMode: WidgetConfigurationSecurityMode.ALLOW_ALL }
  | { domainRestrictionMode: WidgetConfigurationSecurityMode.LIMITED_DOMAINS; allowedDomains: string[] }
);

export interface WidgetConfigurationWebhook {
  url: string;
  attempts: number;
  attempts_interval_seconds: number;
}

export interface WidgetConfiguration {
  styles: WidgetConfigurationStyles;
  logo: WidgetConfigurationLogo;
  content: WidgetConfigurationContent;
  security: WidgetConfigurationSecurity;
  webhook: WidgetConfigurationWebhook | null;
}
